import { dateFormation } from '@helpers/dateFormation';
import { TimeWorkTypeProps } from './TypeProps';
import classNames from 'classnames';

import styles from './TimeWork.module.scss';

export const TimeWork = ({ timework, full, className }: TimeWorkTypeProps) => {
  if (timework) {
    return (
      <>
        {!full ? (
          <div className={className}>Сегодня с {dateFormation(timework)}</div>
        ) : (
          <div className={classNames(styles.Icon, className)} dangerouslySetInnerHTML={{ __html: timework }} />
        )}
      </>
    );
  }
};
